import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Text } from '@/design-system/components/Basic/Typography/Text';

export interface CardDateRowProps {
  label: string;
  value: string;
  className?: string;
}

/**
 * Shared date label + value row used across OHS Hub listing cards.
 * Figma spec: px-2 gap-1 items-baseline (within the card's content area).
 * Uses mt-auto to push to the bottom of a flex column container.
 */
export const CardDateRow: React.FC<CardDateRowProps> = ({ label, value, className }) => (
  <div className={twMerge('flex items-baseline gap-1 mt-auto self-stretch px-2', className)}>
    <Text size="s" className="opacity-60 flex-1 line-clamp-2 overflow-hidden text-ellipsis">
      {label}
    </Text>
    <Text size="s" weight="semibold" className="opacity-60 text-right">
      {value}
    </Text>
  </div>
);
